import { render } from "./KennwortAendern.vue?vue&type=template&id=0f17c405&scoped=true&ts=true"
import script from "./KennwortAendern.vue?vue&type=script&lang=ts"
export * from "./KennwortAendern.vue?vue&type=script&lang=ts"

import "./KennwortAendern.vue?vue&type=style&index=0&id=0f17c405&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f17c405"]])

export default __exports__